export const setupConstants = {
  DETAIL_REQUEST: 'SETUP_DETAIL_REQUEST',
  DETAIL_SUCCESS: 'SETUP_DETAIL_SUCCESS',
  DETAIL_FAILURE: 'SETUP_DETAIL_FAILURE',
  INCREMENT_STEP: 'SETUP_INCREMENT_STEP',
  DECREMENT_STEP: 'SETUP_DECREMENT_STEP',
  SUBMIT_REQUEST: 'SETUP_SUBMIT_REQUEST',
  SUBMIT_SUCCESS: 'SETUP_SUBMIT_SUCCESS',
  SUBMIT_FAILURE: 'SETUP_SUBMIT_FAILURE'
};
